import type { ClickAwayListenerProps } from "@mui/material";
import { ClickAwayListener as MuiClickAwayListener } from "@mui/material";
export function ClickAwayListener(props: ClickAwayListenerProps) {
    return <MuiClickAwayListener {...props}>{props.children}</MuiClickAwayListener>;
}
